module.exports = __webpack_public_path__ + "static/media/VUMeterMask.2d785f83.png";